import React, { FC } from 'react';

interface Props {
  logo: string;
  className?: string;
}

export const Logo: FC<Props> = ({ logo, className }) => <img src={logo} alt="" className={className} />;
